// Store/api/authApi.js
import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: customFetchBase({ url: "auth" }),
  endpoints: (builder) => ({
    // مرحله اول: ارسال شماره تلفن برای دریافت کد
    sendOtp: builder.mutation({
      query: (data) => ({
        url: "/",
        method: "POST",
        body: data, // { phoneNumber: "..." }
      }),
    }),

    // مرحله دوم: لاگین و بررسی کد
    verifyOtp: builder.mutation({
      query: (data) => ({
        url: "/login-otp",
        method: "POST",
        body: data, // { phoneNumber, code, fullName (در صورت ثبت‌نام) }
      }),
    }),

    // ارسال مجدد کد
    resendOtp: builder.mutation({
      query: (data) => ({
        url: "/resend-code",
        method: "POST",
        body: data, // { phoneNumber: "..." }
      }),
    }),
  }),
});

export const {
  useSendOtpMutation,
  useVerifyOtpMutation,
  useResendOtpMutation,
} = authApi;
